// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1lY8s","checkboxCol":"Table_checkboxCol__1y6_j","emailCol":"Table_emailCol__3iGr9","actionCol":"Table_actionCol__1GFcN"};